import React, { useEffect, useRef, useState } from 'react';
import { capitalize, debounce, safeCallback } from '../../../library/helpers';
import { SpinnerIcon } from '../../../design/assets/spinner/spinner.icon';
import classNames from 'classnames';
import { IconButton } from '../../buttons';
import { SearchIcon, XIcon } from '../../../design';
import styles from './searchfield.module.css';
/**
 * @deprecated replaced by 'SearchBar'
 */
export function Searchfield(props) {
    var _a, _b;
    var _c, _d, _e, _f;
    var label = props.variant === 'large' ? props.label : (_c = props.label) !== null && _c !== void 0 ? _c : 'Search';
    var variant = (_d = props.variant) !== null && _d !== void 0 ? _d : 'standard';
    var responsive = (_e = props.responsive) !== null && _e !== void 0 ? _e : false;
    var hasError = !!props.haserror;
    var _g = useState((_f = props.value) !== null && _f !== void 0 ? _f : ''), value = _g[0], setValue = _g[1];
    var inputRef = useRef(null);
    function setValues(tempValue) {
        if (value !== tempValue)
            setValue(tempValue);
        if (!!inputRef.current && inputRef.current.value !== tempValue)
            inputRef.current.value = tempValue;
    }
    function onInputHandler(event) {
        var tempValue = event.currentTarget.value.toString();
        debounce(function () {
            safeCallback(props.onInput, tempValue.trim());
            setValues(tempValue);
        }, 300);
    }
    function onClickHandler() {
        var _a;
        safeCallback(props.onInput, '');
        setValues('');
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    useEffect(function () {
        var _a;
        setValues((_a = props.value) !== null && _a !== void 0 ? _a : '');
    }, [props.value]);
    return (React.createElement("div", { className: classNames('inputWrapperDeprecated', styles.searchfieldWrapper, { responsive: responsive, hasError: hasError }, styles["searchfieldVariant".concat(capitalize(variant))], "kplr_searchfieldWrapper") },
        !props.hideIcon && (React.createElement("div", { className: styles.searchfieldIcon },
            React.createElement(SearchIcon, { tone: "secondary" }))),
        React.createElement("input", { className: classNames(styles.searchfieldInput, (_a = {}, _a[styles.hideIcon] = props.hideIcon, _a)), autoComplete: "off", ref: inputRef, id: label, name: label, type: "search", placeholder: label, onInput: onInputHandler }),
        variant === 'large' && !!props.placeholder && React.createElement("span", { className: styles.searchfieldPlaceholder }, props.placeholder),
        !!label && (React.createElement("label", { className: classNames(styles.searchfieldLabel, (_b = {}, _b[styles.hideIcon] = props.hideIcon, _b)), htmlFor: label }, label)),
        props.loading && (React.createElement("div", { className: styles.searchfieldActionIcon },
            React.createElement(SpinnerIcon, null))),
        !props.loading && !!value && (React.createElement("div", { className: styles.searchfieldActionIcon },
            React.createElement(IconButton, { iconType: "fill", onClick: onClickHandler },
                React.createElement(XIcon, null))))));
}
export default Searchfield;
